import { supabase } from "@/utils/supabase/client";

// Helper function to safely get media URL
function safeGetMediaUrl(media) {
  if (typeof media === "string" && media.trim() !== "") {
    return media;
  }
  if (
    media &&
    typeof media === "object" &&
    media.url &&
    typeof media.url === "string"
  ) {
    return media.url;
  }
  return null;
}

export default function StructuredData({ spaceData }) {
  if (!spaceData?.space_data) return null;

  const space = spaceData.space_data;
  const widgets = spaceData.widgets || [];
  const tags = spaceData.tags || [];
  const spaceUrl = `${process.env.NEXT_PUBLIC_APP_URL}/${space.slug}`;

  // Generate image URLs for structured data
  const images = [];

  // Add bio widget image
  const bioWidget = widgets.find((w) => w.widget_type?.type === "bio");
  if (bioWidget?.config?.image) {
    const bioImageUrl = safeGetMediaUrl(bioWidget.config.image);
    if (bioImageUrl) {
      images.push(bioImageUrl);
    }
  }

  // Add gallery images
  widgets.forEach((widget) => {
    if (widget.widget_type?.type === "image_gallery" && widget.config?.images) {
      widget.config.images.forEach((image) => {
        const imageUrl = safeGetMediaUrl(image);
        if (imageUrl) {
          images.push(imageUrl);
        }
      });
    }
  });

  // Add background image
  if (space.theme?.background?.media) {
    const backgroundImageUrl = safeGetMediaUrl(space.theme.background.media);
    if (backgroundImageUrl) {
      images.push(backgroundImageUrl);
    }
  }

  // Base structured data
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Person",
    name: space.title || "Qensa User",
    url: spaceUrl,
    description:
      space.description || `${space.title || "Digital Space"} on Qensa`,
    image: images.length > 0 ? images[0] : undefined,
    sameAs: [],
  };

  // Add social links from widgets
  widgets.forEach((widget) => {
    if (widget.widget_type?.type === "link" && widget.config?.links) {
      widget.config.links.forEach((link) => {
        if (link.url && typeof link.url === "string") {
          structuredData.sameAs.push(link.url);
        }
      });
    }
  });

  // Add category if available
  if (space.category) {
    structuredData.jobTitle = space.category;
  }

  // Add tags as keywords
  if (tags.length > 0) {
    structuredData.keywords = tags.map((tag) => tag.name).join(", ");
  }

  // Add organization context
  structuredData.memberOf = {
    "@type": "Organization",
    name: "Qensa",
    url: process.env.NEXT_PUBLIC_APP_URL,
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(structuredData),
      }}
    />
  );
}
